/**@flow */

import { all, call, put, takeLatest } from "redux-saga/effects";
import { SetPassword } from "../constants/actions";
import actionCreators from "../actionCreator";
import type { Action } from "redux-action";
import http from "@http";
import qs from "qs";
import { sendSuccessMessage } from "@modules/app/actionCreator";
import { delay } from "@sagas/utils";
import { toast } from "react-toastify";

type ForgotPasswordRequest = $Exact<{
  email: string,
}>;

type SetPasswordRequest = $Exact<{
  newPassword: string,
}>;

export function* onSetPassword({ payload }: Action<SetPasswordRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.newPassword) {
      throw Error("Invalid payload provided");
    }

    const { token } = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { data } = yield call(http.put, "account/password-reset", {
      password: payload.newPassword,
      token,
    });

    yield all([
      put(actionCreators.SetPasswordSuccess(data)),
      put(sendSuccessMessage("PASSWORD_UPDATED_SUCCESS")),
      call(delay, 1000),
      call(url => window.location.assign(url), window.location.origin),
    ]);
  } catch (e) {
    yield put(actionCreators.SetPasswordError(e.response));
  }
}

export function* resetPasswordSaga(): Generator<*, void, void> {
  yield all([takeLatest(SetPassword, onSetPassword)]);
}

export default resetPasswordSaga;
